module.exports = __webpack_public_path__ + "img/alreadyTab.731a3738.png";